var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kpi-grid" }, [
    _c(
      "div",
      {
        staticClass: "kpi kpi-1 kpi-click",
        attrs: {
          title:
            "点击 → 查看全部监控主体 / Clique → ver todas as entidades monitoradas",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("jump", {
              module: "ie-list",
              status: null,
              tip: "已跳转「IE 信息管理」",
            })
          },
        },
      },
      [
        _c("div", { staticClass: "ico-wrap" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
            },
            [
              _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
              _c("path", { attrs: { d: "m9 12 2 2 4-4" } }),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "kpi-main" },
          [
            _c("bi-label", {
              staticClass: "label",
              attrs: { zh: "监控覆盖率", pt: "Cobertura de Monitoramento" },
            }),
            _c(
              "div",
              {
                staticClass: "value",
                style: _vm.coverage < _vm.totalUfs ? { color: "#F53F3F" } : {},
              },
              [_vm._v(_vm._s(_vm.coverage) + " / " + _vm._s(_vm.totalUfs))]
            ),
            _c(
              "div",
              { staticClass: "sub" },
              [
                _vm.missingUf.length
                  ? [
                      _vm._v(
                        " 缺 " +
                          _vm._s(_vm.missingUf.length) +
                          " 州：" +
                          _vm._s(_vm.missingUf.join("、")) +
                          " "
                      ),
                      _c("span", { staticClass: "sub-pt" }, [
                        _vm._v(
                          "Faltam " +
                            _vm._s(_vm.missingUf.length) +
                            " estados: " +
                            _vm._s(_vm.missingUf.join(", "))
                        ),
                      ]),
                    ]
                  : [
                      _vm._v(" 已服务州全部纳入监控 "),
                      _c("span", { staticClass: "sub-pt" }, [
                        _vm._v(
                          "Todos os estados atendidos estão sob monitoramento"
                        ),
                      ]),
                      _c("span", { staticClass: "pct-ok" }, [
                        _vm._v("↑ " + _vm._s(_vm.percent) + "%"),
                      ]),
                    ],
              ],
              2
            ),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "kpi kpi-2 kpi-click",
        attrs: {
          title:
            "点击 → 查看异常主体清单 / Clique → ver lista de entidades com exceção",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("jump", {
              module: "ie-list",
              status: 3,
              tip: "已筛选「异常」主体：" + _vm.anomalyCount + " 条",
            })
          },
        },
      },
      [
        _c("div", { staticClass: "ico-wrap" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.4 0z",
                },
              }),
              _c("path", { attrs: { d: "M12 9.2v4" } }),
              _c("circle", {
                attrs: {
                  cx: "12",
                  cy: "16.4",
                  r: "1.1",
                  fill: "currentColor",
                  stroke: "none",
                },
              }),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "kpi-main" },
          [
            _c("bi-label", {
              staticClass: "label",
              attrs: { zh: "异常主体数", pt: "Entidades com Exceção" },
            }),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.anomalyCount)),
            ]),
            _vm._m(0),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "kpi kpi-3 kpi-click",
        attrs: { title: "点击 → 查看告警日志 / Clique → ver log de alertas" },
        on: {
          click: function ($event) {
            return _vm.$emit("jump", {
              module: "alert-log",
              tip: "已跳转「告警日志」",
            })
          },
        },
      },
      [
        _c("div", { staticClass: "ico-wrap" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
            },
            [
              _c("path", {
                attrs: { d: "M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" },
              }),
              _c("path", { attrs: { d: "M13.7 21a2 2 0 0 1-3.4 0" } }),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "kpi-main" },
          [
            _c("bi-label", {
              staticClass: "label",
              attrs: { zh: "今日告警次数", pt: "Alertas de Hoje" },
            }),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.alertTotal)),
            ]),
            _c("div", { staticClass: "sub" }, [
              _vm._v(" " + _vm._s(_vm.alertTypeText) + " "),
              _c("span", { staticClass: "sub-pt" }, [
                _vm._v(_vm._s(_vm.alertTypeTextPt)),
              ]),
            ]),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "kpi kpi-4",
        class: { "is-delayed": _vm.checkDelayed },
        attrs: {
          title: _vm.checkDelayed
            ? "距上次检查已超过 30 分钟，请确认定时任务是否正常触发"
            : "",
        },
      },
      [
        _c("div", { staticClass: "ico-wrap" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
              },
            },
            [
              _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
              _c("path", { attrs: { d: "M12 6v6l4 2" } }),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "kpi-main" },
          [
            _c("bi-label", {
              staticClass: "label",
              attrs: { zh: "上次检查时间", pt: "Última Verificação" },
            }),
            _c(
              "div",
              {
                staticClass: "value is-time",
                style: _vm.checkDelayed ? { color: "#F53F3F" } : {},
              },
              [_vm._v(_vm._s(_vm.fmtTime(_vm.schedule.at)))]
            ),
            _c("div", { staticClass: "sub" }, [
              _vm._v(
                " 下次定时：" + _vm._s(_vm.fmtTime(_vm.schedule.nextAt)) + " "
              ),
              _c("span", { staticClass: "sub-pt" }, [
                _vm._v(
                  "Próxima execução: " +
                    _vm._s(_vm.fmtTime(_vm.schedule.nextAt))
                ),
              ]),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub" }, [
      _vm._v(" 点击卡片筛选异常主体 "),
      _c("span", { staticClass: "sub-pt" }, [
        _vm._v("Clique no cartão para filtrar as entidades com exceção"),
      ]),
      _c("span", { staticClass: "pct-up" }, [_vm._v("›")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }